import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Auto-closes the Bootstrap modal when this controller connects.
// Used by turbo_stream responses to dismiss the modal after form submission.
export default class extends Controller {
  connect() {
    const modalEl = document.getElementById("turbo-modal")
    if (modalEl) {
      const modal = bootstrap.Modal.getInstance(modalEl)
      if (modal) modal.hide()
    }
  }
}
